import type { LandingDict } from './en';

const es: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "Crear app", org: "My Org", pricing: 'Precios', privacy: "Privacidad", contact: "Contacto", language: 'Idioma' },
  hero: {
    titlePre: 'Tu central\n',
    titleMark: 'de IA local.',
    titlePost: '',
    sub: "Convierte conocimiento experto, hojas de cálculo y reuniones en respuestas, gráficos y presentaciones. Nada sale de tu Mac.",
    watch: "Ver el vídeo de 2 min",
    pill: "Última versión",
    chip: "Wi‑Fi apagado · 0 bytes enviados",
    badges: { offline: "Funciona sin conexión", server: "Tu servidor, no el nuestro", free: "Gratis para empezar" },
    reqs: 'Requiere un Mac con Apple Silicon · 16 GB de memoria como mínimo · Con 32 GB o más, puedes usar los modelos recomendados más grandes',
  },
  stats: {
    free: 'Gratis',
    freeSub: 'Todas las Chat Apps, descargas de modelos y actualizaciones. Siempre.',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'bytes enviados a la nube cuando la IA se ejecuta en este Mac',
    langsSub: 'idiomas de interfaz, del español al 日本語',
  },
  film: { kicker: 'El video', title: 'Mira Estha en acción.', watchOnYouTube: 'Ver en YouTube', trouble: '¿No se reproduce? Míralo en YouTube ↗' },
  overview: {
    kicker: 'Una app, cuatro formas de trabajar',
    title: 'Del chat a los agentes,\ny a las apps de todo tu equipo.',
    explore: 'Explorar',
    chat: { title: 'Chat Apps', desc: 'Expertos de IA basados en bases de conocimiento cuidadosamente seleccionadas: libros de texto, manuales y conocimientos especializados.', tag: 'Siempre gratis' },
    agentic: { title: 'Agentic Apps', desc: 'Agentes de IA orientados a tareas que gestionan trabajos complejos de principio a fin.', tag: '{n} y vienen más' },
    build: { title: "Crear app", desc: 'Convierte tus propios materiales en una Chat App con Quick Bot o diseña flujos en el lienzo de Playground.', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: 'El espacio de apps de tu organización, con su propia marca, apps revisadas y acceso controlado.', tag: 'Enterprise' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: 'IA experta, basada en conocimiento real.',
    freePill: 'Siempre gratis',
    lede: 'Cada Chat App incluye su propia base de conocimiento, indexada directamente en tu Mac.',
    feats: {
      kb: { title: 'Bases de conocimiento locales', desc: 'Al instalar una app, su base de conocimiento se crea en tu Mac: las respuestas salen de material seleccionado.' },
      files: { title: 'Usa tus propios archivos', desc: 'Adjunta imágenes, PDF, DOCX, TXT o MD. Los documentos largos usan recuperación inteligente.' },
      browse: { title: 'Explora, fija, guarda en favoritos', desc: 'Categorías de Evaluación a Carrera profesional, etiquetas NEW para las apps recién llegadas y ⌘K para buscarlo todo.' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} Agentic Apps.\nY vienen más.',
    lede: 'De una hoja de cálculo, un PDF, una grabación o una idea a un gráfico, una presentación, un documento o un prototipo terminados. En privado, en tu Mac.',
    seeThem: 'Míralas en acción',
  },
  build: {
    kicker: 'Crear app',
    title: 'Crea tu propia Chat App.\nEn tu Mac.',
    lede: 'Convierte tus archivos en una Chat App: se indexa en local y la publicas cuando quieras.',
    quick: {
      badge: 'Recomendado',
      desc: 'Sube una base de conocimiento y escribe un prompt de sistema, luego publica. Ideal para convertir materiales en un bot de preguntas y respuestas rápidamente.',
      items: ['Formulario de una página, hecho en unos pocos pasos', 'Preguntas y respuestas con base de conocimiento listas para usar', 'Plantillas de prompt integradas para inspirarte'],
    },
    advanced: {
      title: 'Avanzado · Playground',
      desc: 'Editor visual de nodos para componer libremente varios nodos, ramas, AB test y enrutamiento por palabras clave.',
      items: ['Lienzo de nodos', 'Múltiples nodos / ramas / AB test', 'Campos detallados y depuración'],
    },
    guideTitle: 'Una guía de IA local te acompaña en todo momento.',
    guideText: 'Cuéntale qué quieres que haga tu app y te indicará qué nodos arrastrar y cómo conectarlos. La creación de apps está incluida en Premium.',
  },
  private: {
    kicker: 'Privado por diseño',
    title: "Sin nube para tus datos.\nSin rastreo de tu trabajo.",
    lede: "Tú decides dónde se ejecuta la IA. Por defecto, Estha elige el modelo adecuado para cada función, y puedes cambiarlo cuando quieras en la app.",
    boundary: "Límite de los datos = tu red",
    local: { title: 'En este Mac', desc: 'Totalmente sin conexión, nada sale de este equipo. Ejecuta los modelos con la memoria de este Mac.', best: 'Ideal para Macs con memoria de sobra' },
    server: { title: 'En mi Estha Server', desc: 'Delega el trabajo pesado en un Mac más potente de tu red y mantén este Mac ligero.', best: 'Ideal para portátiles y Macs con poca memoria' },
    cluster: { desc: 'Conéctate a un clúster de Mac Studio para delegar la inferencia pesada y mantener tus datos en local.', best: 'Detecta automáticamente los nodos Estha Studio Master de tu red' },
    models: {
      every: 'Funciona en todos los Mac compatibles',
      whisper: "Whisper para transcripción",
      recommended: 'Los modelos recomendados',
      larger: "Modelos Qwen y Gemma más grandes",
      vision: "Modelos de visión para imágenes",
      open: 'Modelos abiertos, optimizados para Apple Silicon',
      openItems: ['Descarga y cambia de modelo desde la app', 'Modelos dedicados para código y embeddings', 'Descargas de modelos siempre gratis'],
    },
  },
  org: {
    kicker: 'My Org',
    title: 'El espacio de apps de IA de tu organización.',
    lede: 'Una sección de Estha con la marca de tu organización y las apps que ha revisado para su gente.',
    signIn: 'Inicia sesión en My Org Admin',
    talk: 'Habla con el equipo de Estha',
    feats: {
      review: { title: 'Revisión antes de publicar', desc: 'Cada app nueva, actualización o retirada pasa por un administrador. Los rechazos siempre incluyen comentarios por escrito.' },
      access: { title: 'Acceso por grupo o por persona', desc: 'Decide exactamente quién ve cada app: por departamento, equipo o persona.' },
      brand: { title: 'Tu marca, dentro de la app', desc: 'Nombre de la organización, mensaje de bienvenida, logotipo, banner y color del tema, con vista previa antes de publicarlos.' },
    },
  },
  pricing: {
    kicker: 'Membresía',
    title: 'Empieza gratis. Desbloquéalo todo cuando quieras.',
    free: { name: 'Gratis', sub: 'Siempre gratis.', items: ["Todas las Chat Apps", 'Procesamiento de documentos, gratis para siempre', 'Descargas de modelos, software y actualizaciones — siempre gratis'] },
    premium: {
      name: 'Premium', flag: 'Prueba gratis de 14 días', firstYear: 'el primer año',
      sub: 'Después, US$30 al año. Verifica tu correo y empieza con una prueba gratis de 14 días.',
      items: ['Todo lo de Gratis', 'Todas las Agentic Apps actuales y futuras', 'Creador de Chat Apps — crea, edita, previsualiza, guarda y publica chatbots locales'],
      cta: 'Empieza la prueba en la app',
    },
    enterprise: {
      name: 'Enterprise', price: 'Hablemos', sub: 'Para organizaciones que implementan Estha en sus equipos.',
      items: ['Todo lo de Premium', 'Chat Apps y Agentic Apps personalizadas para tu equipo', 'Capacidad de la app Estha Server', 'Espacio de apps My Org y My Org Admin'],
    },
  },
  faq: {
    title: 'Lo que debes saber\nantes de descargar.',
    spec: { chip: 'Chip', memory: 'Memoria', memMin: '16 GB como mínimo', memRec: '32 GB o más para los modelos recomendados', languages: 'Idiomas', langsVal: '13 idiomas de interfaz', version: 'Última versión' },
    qa: [
      { q: '¿Sale algo de mi Mac?', a: 'Cuando la IA se ejecuta en este Mac, funciona totalmente sin conexión: nada sale del equipo. Si eliges un Estha Server o un clúster de Mac Studio, el trabajo solo se envía a esa máquina, dentro de tu propia red.' },
      { q: "¿Qué necesita conexión a internet?", a: "Muy pocas cosas: iniciar sesión y verificar tu correo para la prueba Premium, descargar modelos y buscar actualizaciones. Tus instrucciones, archivos y resultados nunca se suben: una vez descargado el modelo, la IA funciona totalmente sin conexión." },
      { q: '¿Qué es gratis y qué incluye Premium?', a: 'Todas las Chat Apps, el Procesamiento de documentos, las descargas de modelos y las actualizaciones son gratis. Premium desbloquea todas las Agentic Apps actuales y futuras, además del creador de Chat Apps, con una prueba gratis de 14 días.' },
      { q: '¿Qué modelos de IA usa?', a: 'Modelos de código abierto líderes, como Qwen y Gemma, además de Whisper para la transcripción, ejecutados con el motor MLX de Apple. Los descargas y cambias desde la propia app.' },
      { q: '¿Puedo crear mi propia app?', a: 'Sí. Con Quick Bot conviertes hasta tres archivos en una Chat App con base de conocimiento en pocos pasos; con el lienzo de nodos de Playground puedes crear ramas, AB tests y cuestionarios. Una guía de creación local te ayuda en el camino.' },
      { q: '¿Cómo lo implementa una organización?', a: 'Con Enterprise, los administradores gestionan usuarios y grupos en My Org Admin y revisan cada app antes de publicarla; los miembros tienen su propio espacio My Org con la marca de la organización dentro de Estha. Escríbenos a {email}.' },
    ],
  },
  final: { title: '¿Todo listo para ejecutar IA en local?', reqs: 'Funciona en cualquier Mac con Apple Silicon · 16 GB de RAM como mínimo' },
  footer: {
    tagline: 'Tu central de IA local: en el dispositivo, con tecnología MLX y privada por diseño.',
    product: 'Producto', createApp: 'Crear app', pricing: 'Precios',
    orgs: "My Org", signIn: 'Iniciar sesión en My Org Admin',
    security: "Seguridad", changelog: "Novedades", docs: "Documentación", support: "Soporte",
    company: 'Empresa', privacy: 'Política de privacidad', terms: 'Condiciones del servicio',
    rights: '© 2026 Estha. Todos los derechos reservados.',
  },
  proof: { press: "Han hablado de nosotros", voices: "Lo que dicen los equipos" },
  contact: {
    title: "Escribe al equipo de Estha", copy: "Copiar dirección de correo", copied: "Copiado",
    gmail: "Escribir en Gmail", mailApp: "Abrir en la app Mail",
    subject: "Consulta sobre Estha for Mac",
  },
  share: {
    button: "Compartir", title: "Compartir Estha",
    sub: "Elige una tarjeta y publícala, o simplemente envía el enlace.",
    style: "Tarjeta", size: "Tamaño",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "Privacidad" },
    landscape: "Horizontal", portrait: "Vertical",
    shareImage: "Compartir imagen…", download: "Descargar imagen", copyImage: "Copiar imagen", copied: "Copiado",
    copyLink: "Copiar enlace", link: "Enlace", postTo: "Publicar en",
    email: "Correo",
    text: "Estha ejecuta modelos de IA de código abierto por completo en tu Mac: privado, sin conexión y gratis.",
    cardCta: "Descarga gratuita para Mac con Apple Silicon",
    close: "Cerrar",
  },
  apps: {
    dataAnalyst: { name: 'Analista de datos', description: 'Sube archivos CSV/Excel y haz preguntas en lenguaje natural. Genera automáticamente gráficos, análisis estadísticos e información sobre los datos, todo procesado localmente en tu Mac.', tags: ['CSV / Excel', 'Gráficos automáticos', 'Consulta en lenguaje natural', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'Describe el tema de tu presentación y obtén una presentación de PowerPoint con una estructura profesional. Un proceso de IA de varios pasos genera el esquema, el contenido de cada diapositiva y un archivo .pptx pulido.', tags: ['Salida .pptx', 'Diseño automático', 'Proceso de varios pasos'] },
    pdfReader: { name: 'Lector de PDF', description: 'Abre un PDF y conversa con él. Cada respuesta se basa en el documento, con citas clicables que saltan al pasaje de origen exacto — todo procesado localmente en tu Mac.', tags: ['Preguntas al PDF', 'Citas verificables', 'Preguntar selección', '100 % local'] },
    documentProcessing: { name: 'Procesamiento de documentos', description: 'Tu experto en documentos todo en uno. Redacta entradas de blog, textos para redes sociales, cláusulas legales y documentos empresariales desde cero. Edita y optimiza archivos existentes, traduce entre idiomas y revisa el contenido para garantizar su calidad, todo de forma privada en tu Mac.', tags: ['Redacción y escritura', 'Edición y optimización', 'Traducción', 'Revisión y auditoría'] },
    meetingIntelligence: { name: 'Inteligencia de reuniones', description: 'Graba, transcribe y analiza reuniones con IA. Genera automáticamente actas, tareas pendientes y decisiones clave, con total privacidad: el audio nunca sale de tu dispositivo.', tags: ['Transcripción', 'Actas de reunión', 'Tareas pendientes', '100 % privado'] },
    vibeCoding: { name: 'Vibe Coding: Prototipo', description: 'Crea vistas previas interactivas con IA. Describe una interfaz en lenguaje natural, obtén un prototipo en el que puedes hacer clic y sigue iterando sobre él. Genera un único archivo .html autónomo, creado por completo en tu Mac.', tags: ['Archivo .html único', 'Vista previa interactiva', 'Edición por clic', '100 % local'] },
    translate: { name: "Traducir", description: "Traduce texto y documentos Word, de texto o Markdown con un glosario compartido que mantiene tus términos coherentes, todo procesado localmente en tu Mac.", tags: ["Texto y documentos", ".docx / .txt / .md", "Glosario", "100 % local"] },
  },
  screens: {
    chat: [
      { label: 'Explora la tienda', caption: 'Explora, instala, fija — siempre gratis' },
      { label: 'Instala', caption: 'La base de conocimiento se crea en tu Mac al instalar' },
      { label: 'Pregunta', caption: 'Respuestas basadas en su propio manual' },
    ],
    build: [
      { label: 'Crear app', caption: 'Quick Bot o Avanzado: ambos listos para chatear' },
      { label: 'Quick Bot', caption: 'Sube una base de conocimiento. Escribe un prompt. Publica.' },
      { label: 'Playground', caption: 'Nodos, ramas y conocimiento, de forma visual' },
      { label: 'Publicada', caption: 'Publicada y lista para chatear' },
    ],
    analyst: [
      { label: 'Haz una pregunta', caption: 'Pregúntale a tus datos en lenguaje natural' },
      { label: 'Analizando', caption: 'Analizado en tu Mac' },
      { label: 'Gráfico y conclusiones', caption: 'La respuesta, el gráfico y cómo se obtuvo' },
    ],
    ppt: [
      { label: 'Configura', caption: 'Tema, diapositivas, idioma, tono y estilo' },
      { label: 'Revisa el esquema', caption: 'Edita el esquema antes de generar nada' },
      { label: 'Vista previa', caption: 'Un .pptx terminado y editable, en tu Mac' },
    ],
    pdf: [
      { label: 'Abre un PDF', caption: 'Artículos, informes, manuales y documentos escaneados' },
      { label: 'Leyendo', caption: 'Lectura local, página a página' },
      { label: 'Respuesta con cita', caption: 'Cada respuesta remite a la cláusula exacta' },
    ],
    doc: [
      { label: 'Selecciona un pasaje', caption: 'Selecciona texto y di lo que quieres' },
      { label: 'Reescribiendo', caption: 'Reescrito directamente en el documento' },
      { label: 'Acepta o rechaza', caption: 'Reescribe, pule, traduce — acepta o rechaza' },
    ],
    meeting: [
      { label: 'Graba', caption: 'Transcripción en directo, en este Mac' },
      { label: 'Elige qué generar', caption: 'Elige qué quieres obtener' },
      { label: 'Resumen', caption: 'Decisiones y tareas, redactadas para ti' },
      { label: 'Tareas pendientes', caption: 'Responsables y fechas, con evidencias' },
    ],
    vibe: [
      { label: 'Describe', caption: 'Describe una interfaz en lenguaje natural' },
      { label: 'Generando', caption: 'Creado íntegramente en este Mac' },
      { label: 'Prototipo', caption: 'Interactivo, con versiones, en un solo .html' },
      { label: 'Edición por clic', caption: 'Selecciona cualquier parte y di qué cambiar' },
    ],
    translate: [
      { label: "Traducir texto", caption: "Las palabras en morado vienen de tu glosario" },
      { label: "Traducir un documento", caption: ".docx, .txt o .md: el original no cambia" },
      { label: "Glosario", caption: "Tu glosario mantiene cada término coherente" },
    ],
    private: [
      { label: 'En este Mac', caption: 'Totalmente sin conexión. Nada sale de este equipo.' },
      { label: 'Mac Studio Cluster', caption: 'Modelos más grandes, en tus instalaciones' },
    ],
    org: [
      { label: 'Espacio de la organización', caption: 'Espacio con tu marca y apps creadas para tu equipo' },
      { label: 'Plan Enterprise', caption: 'Cada miembro abre solo las apps que le asignas' },
    ],
  },
};

export default es;
